import MoreItemsIcon from '@/common/assets/icons/moreItemsIcon.svg?react';
import MoreItemsModal from '@/common/components/imageGallery/components/Extensions/moreItemsExtension/MoreItemsModal';
import { MoreItemsExtensionProps } from '@/common/components/imageGallery/types/imageCard.type';
import useModal from '@/common/hooks/useModal';
import { Box } from 'styled-system/jsx';

export const MoreItemsExtension = ({
  src,
  handleClick,
  items,
  deleteImageLoading,
}: MoreItemsExtensionProps) => {
  const { open, openModal, closeModal } = useModal();
  return (
    <>
      <Box onClick={openModal} position="absolute" top="0.5rem" left="0.5rem">
        <MoreItemsIcon />
      </Box>
      <MoreItemsModal
        deleteImageLoading={deleteImageLoading}
        closeModal={closeModal}
        open={open}
        src={src}
        handleClick={handleClick}
        items={items}
      />
    </>
  );
};
